<template>
  <div class="top-nav">
    <b-container>
      <b-row>
        <b-col class="text-center black-bg">
          <img src="../assets/journey2.jpg" class="w-100" alt="Man Walking Out of Canyon Exit" /> 
          <h1 class="text-white">The Journey of Vagabond's Quest</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="black-boarder">
          <p>
            Game development is hard; indy game development is even harder.  In many
            respected the first rendition of Vagabond's Quest was a walk in the park;
            I was a naive young teenager that learned some web programming and ran
            a web server up on my Windows 95 desktop.  It grew beyond my wildest
            dreams, and people were playing a game that I had created!  I felt like a
            god, an unimaginable thing for someone in their early twenties, and nothing
            was going to stop me! <em>(hint: sarcasm)</em>
          </p>
          <p>
            Then the dot com bubble burst, but my dreams of what Vagabond's Quest should,
            and could, be did not.  I struggled for about a year or so to keep the core
            team working on VQ2 together, but money was leaving the bank account.
            Eventually, I had to make the tough decision to try and go back to the
            one-person show that had started everything.  A few years into that and I was
            deeply depressed, deeply lonely, and thoroughly addicted to World of Warcraft.
            At the height of the great recession, I finally threw in the towel and gave up
            on my dreams of bringing the true Vagabond's Quest into the world.  It was the
            most challenging decision I had ever made, and was the darkest day of my life.
          </p>
          <p>
            Now, nearly ten years after that fateful day, I have decided to bring the
            dream back from the dead.  During the past three years, the ideas of how to
            travel successfully along this winding trail have been percolating. The dream
            has risen from the ashes of the past like a Phoenix.  The benefits of hindsight
            and wisdom that comes from experience have made me a better person and shown
            me that the journey is long and that I have only just started upon it. More
            importantly, it has shown me that I am more than the games I create.
          </p>
          <p>
            The roadmap is an outline of the individual mileposts to hit along this long
            and winding road.  It is broken down into phases, and more detail will be
            added to the later phases as this adventure progresses.  This roadmap is to
            provide the community with information.  It is also to hold me acountable to
            make steady progress towards these objectives. 
          </p>
          <div class="text-right lead">-- Falados</div>
        </b-col>
      </b-row>    
      <b-row>
        <b-col>
          <b-tabs content-class="mt-3">
            <b-tab title="Phase 1" active>
              <div class="text-center">
                <img src="../assets/pit_fight_roadmap.jpg" class="w-75" alt="Two Warriors Fighting" /> 
              </div>
              <h2 class="text-center">Remake Web Pit Fighting</h2>
              <p><strong>Prerequisites:</strong> None</p>
              <p>
                <strong>Objective:</strong> Prove to myself that I still have what it takes
                to start and finish a game.  Prove to the VQ community that the dream is not
                dead and that VQ is back.  Nail the RPG system through constant feedback and
                iteration. Learn Go, AWS, Web App Development, and Responsive Website Design.
              </p>
              <b-form-checkbox size="lg" id="p1m1" v-model="p1m1" disabled class="larger-text">Loot System{{ p1m1Text }}</b-form-checkbox>
              <b-form-checkbox size="lg" id="p1m1" v-model="p1m2" disabled class="larger-text">Character Creation{{ p1m2Text }}</b-form-checkbox>
              <b-form-checkbox size="lg" id="p1m1" v-model="p1m3" disabled class="larger-text">Interactive Characters{{ p1m3Text }}</b-form-checkbox>
              <b-form-checkbox size="lg" id="p1m1" v-model="p1m4" disabled class="larger-text">Website{{ p1m4Text }}</b-form-checkbox>
              <b-form-checkbox size="lg" id="p1m1" v-model="p1m5" disabled class="larger-text">Closed Alpha{{ p1m5Text }}</b-form-checkbox>
              <b-form-checkbox size="lg" id="p1m1" v-model="p1m6" disabled class="larger-text">Closed Beta{{ p1m6Text }}</b-form-checkbox>
              <b-form-checkbox size="lg" id="p1m1" v-model="p1m7" disabled class="larger-text">Public Beta{{ p1m7Text }}</b-form-checkbox>              
            </b-tab>
            <b-tab title="Phase 2">
              <div class="text-center">
                <img src="../assets/dod.jpg" class="w-75" alt="Entrance to the Dungeon of Despair" /> 
              </div>
              <h2 class="text-center">Dungeon of Despair Prototype</h2>
              <p><strong>Prerequisites:</strong> VQ earning enough to quit my day job</p>
              <p>
                <strong>Objective:</strong> Take VQ out of the turn-based world and bring
                it into a realtime fully 3d isometric world.  Nail the primary combat
                game loop through feedback and iteration.
              </p>
              <p>Mileposts will follow when Phase 1 is finished.</p>
            </b-tab>
            <b-tab title="Phase 3">
              <div class="text-center">
                <img src="../assets/dod.jpg" class="w-75" alt="Entrance to the Dungeon of Despair" /> 
              </div>
              <h2 class="text-center">Dungeon of Despair Early Access Worthy</h2>
              <p><strong>Prerequisites:</strong> VQ earning enough to pay a couple real artists
              <p><strong>Objective:</strong> Refine, polish, and add content to the Prototype.  Release VQ on Steam Early Access.
              <p>Mileposts will follow when Phase 2 is finished.</p>
            </b-tab>
            <b-tab title="Phase 4">
              <h2 class="text-center">MMORPG</h2>
              <p><strong></strong>VQ earning enough to have an indy studio of about eight people.</p>
              <p><strong>Objective:</strong> See <a href="/why/">Why Vagabond's Quest is needed</a>.
              <p>Mileposts will follow when Phase 3 is finished.</p>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        p1m1: true,
        p1m1Text: ': Done (December 2018)',
        p1m2: true,
        p1m2Text: ': Done (May 2019)',
        p1m3: true,
        p1m3Text: ': Done (July 2019)',
        p1m4: true,
        p1m4Text: ': Done (August 2019)',
        p1m5: true,
        p1m5Text: ': Done (October 2019)',
        p1m6Text: ': In Progress (November 2019)'
      }
    }
  }
</script>

<style scoped>
.top-nav {
  margin-top: 2.5em;
  font-size: 13pt;
}
.darker {
  background-color: #ccc;
  border-radius: 1em 1em 0px 0px;
  padding: 0.4em;
  padding-bottom: 0.2em;
  color: #fff;
  margin: 0.5em;
  margin-bottom: 0px;
}
.darker-boarder {
  border-style: solid;
  border-width: 0.1em;
  border-color: #ccc;
  margin: 0.5em;
  margin-top: 0px;
  margin-bottom: 1.5em;
  border-radius: 0px 0px 1em 1em;
  padding: 1.0em;
  background-color: #f6f6f6;
}
.black-bg {
  background-color: #000;
  color: #fff;
  padding: 0.0em;
  margin: 0.5em;
  margin-bottom: 0px;
}
.black-boarder {
  border-style: solid;
  border-width: 0.1em;
  border-color: #000;
  margin: 0.5em;
  margin-top: 0px;
  margin-bottom: 1.5em;
  border-radius: 0px 0px 1em 1em;
  padding: 1.0em;
  background-color: #f6f6f6;
}
.text-white {
  color: #fff;
}
.larger-text {
  font-size: 13pt;
}
</style>